"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("@osmosys/utils");
class Frame extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.iframeElement = react_1.default.createRef();
    }
    componentDidMount() {
        if (this.iframeElement && this.iframeElement.current) {
            this.iframeElement.current.onload = () => {
                this.applySafeguards();
            };
        }
    }
    applySafeguards() {
        if (!this.iframeElement.current.contentDocument) {
            return;
        }
        // Make all links open in new tab
        // let head = this.iframeElement.contentDocument.querySelector('head');
        // if (!head) {
        //   head = this.iframeElement.contentDocument.createElement('head');
        //   this.iframeElement.contentDocument.prepend(head);
        // }
        // const newBaseEl = this.iframeElement.contentDocument.createElement('base');
        // newBaseEl.setAttribute('target', '_blank');
        // head.appendChild(this.iframeElement);
        this.iframeElement.current.contentDocument
            .querySelectorAll('a')
            .forEach(el => {
            el.setAttribute('target', '_blank');
        });
        // head.innerHTML = `${head.innerHTML}${newBaseEl.outerHTML}`;
    }
    render() {
        const _a = this.props, { src } = _a, rest = tslib_1.__rest(_a, ["src"]);
        utils_1.logger.info({ src });
        return react_1.default.createElement("iframe", Object.assign({}, rest, { ref: this.iframeElement }));
        // return React.createElement('iframe', {
        //   ref: this.iframeElement,
        //   referrerPolicy,
        //   sandbox,
        //   srcDoc,
        //   title,
        //   ...rest,
        // });
    }
}
exports.Frame = Frame;
Frame.defaultProps = {
    referrerPolicy: 'no-referrer',
    sandbox: 'allow-same-origin',
    src: '',
    title: '',
};
//# sourceMappingURL=Frame.js.map